(() => {
  if (customElements.get('avontic-family-experience')) return;

  class AvonticFamilyExperience extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      delete this.dataset.ready;
    }

    handleClick = (event) => {
      const option = event.target.closest('[data-family-option-value]');
      if (option) this.selectNativeOption(option.dataset.familyOptionValue || '');

      const configure = event.target.closest('[data-family-return-configuration]');
      if (configure) this.returnToConfiguration();
    };

    selectNativeOption(exactValue) {
      const picker = document.querySelector('#avontic-primary-product variant-picker');
      if (!picker || !exactValue) {
        this.setStatus(this.dataset.optionNotFoundMessage);
        this.returnToConfiguration();
        return;
      }

      const matches = Array.from(picker.querySelectorAll('label[for]')).filter((label) => {
        const input = document.getElementById(label.htmlFor);
        return input && !input.disabled && label.textContent.trim() === exactValue;
      });

      if (matches.length !== 1) {
        this.setStatus(matches.length > 1 ? this.dataset.optionAmbiguousMessage : this.dataset.optionNotFoundMessage);
        this.returnToConfiguration();
        return;
      }

      const input = document.getElementById(matches[0].htmlFor);
      input.click();
      input.focus({ preventScroll: true });
      if (
        window.AvonticDeviceProfile
        && /ipad|iphone|galaxy|pixel|watch|surface|fitbit|garmin|razr|oneplus|macbook|\ba\d{4}\b|\bsm[-\s]?[a-z]?\d{3,4}\b/i.test(exactValue)
      ) {
        window.AvonticDeviceProfile.setActive(exactValue, {
          source: 'product-family',
          reason: 'exact-option-selected'
        });
      }
      this.setStatus(this.dataset.optionSelectedMessage);
      this.returnToConfiguration(false);
    }

    returnToConfiguration(moveFocus = true) {
      const picker = document.querySelector('#avontic-primary-product variant-picker');
      const target = picker || document.querySelector('#avontic-primary-product');
      if (!target) return;
      target.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'center'
      });
      if (moveFocus) {
        const focusTarget = target.querySelector('input:not([disabled]), button:not([disabled]), select:not([disabled])');
        window.setTimeout(() => focusTarget?.focus({ preventScroll: true }), 200);
      }
    }

    setStatus(message) {
      const status = this.querySelector('[data-family-status]');
      if (status) status.textContent = message || '';
    }
  }

  customElements.define('avontic-family-experience', AvonticFamilyExperience);
})();
